import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Não anexa Authorization nas rotas públicas/no-auth
    const isPublicRequest = /\/no-auth\//.test(req.url) || /\/login$/.test(req.url);
    const currentUrl = this.router.url || '/imoveis';

    const token = this.auth.getToken();
    const authReq = !isPublicRequest && token
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;

    return next.handle(authReq).pipe(
      catchError((err: HttpErrorResponse) => {
        if ((err.status === 401 || err.status === 403) && !isPublicRequest) {
          this.auth.logout();
          void this.router.navigate(['/auth'], {
            queryParams: { r: currentUrl === '/auth' ? '/imoveis' : currentUrl }
          });
        }
        return throwError(() => err);
      })
    );
  }
}
